<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { BaseToggleButton } from '@/components/Base';
import { ViewMode } from "@/enums/ViewMode";

const { t } = useI18n();

withDefaults(defineProps<{
  currentView?: ViewMode;
}>(), {
  currentView: ViewMode.Video
});

const emit = defineEmits<{
  viewChanged: [mode: ViewMode]
}>();

function switchView(mode: ViewMode) {
  emit('viewChanged', mode);
}
</script>

<template>
  <div class="bottom-bar">
    <div class="view-toggle">
      <BaseToggleButton
        icon="video"
        :label="t('video.toggleVideo')"
        :active="currentView === ViewMode.Video"
        @click="switchView(ViewMode.Video)"
      />
      <BaseToggleButton
        icon="chat"
        :label="t('video.toggleChat')"
        :active="currentView === ViewMode.Chat"
        @click="switchView(ViewMode.Chat)"
      />
    </div>
  </div>
</template>

<style scoped>
.bottom-bar {
  background-color: var(--color-primary);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}

.view-toggle {
  display: flex;
  gap: var(--spacing-lg);
  width: 100%;
  justify-content: space-around;
}
</style>
